var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaryland(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.458,165.006l-35.039,5.797c0,0-11.841-52.187-21.836-80.519c-1.05-2.969-3.387-8.786-3.546-9.146 c0,0-142.637,29.24-204.438,40.691l8.278,36.416l15.725-21.516l7.449-0.415l9.933-15.312c0,0,6.621,3.725,11.175,4.277 c4.553,0.55,21.104-13.794,24.414-13.794c3.313,0,27.315,16.551,27.315,16.551l15.312,8.279v6.831v3.515 c0,0,24.832,6.622,28.555,14.898c3.725,8.275-0.827,13.658-3.723,17.38c-2.898,3.726-0.83,10.761,0,14.9 c0.826,4.138,16.136,4.551,16.136,4.551s29.25,4.688,31.455,3.864c2.208-0.83,3.863-7.177,3.311-9.382 c-0.551-2.208-12.688-17.655-12.688-17.655l-6.622-20.144c0,0,5.794-14.346,5.242-19.036c-0.553-4.69-3.26-7.724-3.26-7.724 l3.534-14.625l13.902-10.206l3.478,4.69c0,0-12.691,18.758-9.932,19.312c2.759,0.549,7.45,3.584,7.45,3.584l0.553,18.485 l-6.07,3.362l2.206,7.951l5.793-0.275l3.312,4.412c0,0-6.897,2.484-5.24,11.035c1.653,8.555,7.173,14.408,14.62,14.931 c7.452,0.521,11.589-1.136,11.589-1.136s9.104,16.555,12.14,16.555c0.518,0,1.558-0.252,2.914-0.67 c6.589-2.004,20.814-7.881,20.814-7.881s0.934-0.551,2.115-2.092C273.439,192.271,277.325,183.743,274.458,165.006z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaryland);
export default __webpack_public_path__ + "static/media/maryland.3990787bc227148b7ca2f35cdd59ad97.svg";
export { ForwardRef as ReactComponent };